import {Constants} from "graph-netecs/js/Constants";

class ErpBafa {
    constructor(store, workOnInverter, frequency, workFrequency, fan, calculator, silentMode = false, forcedData = {}) {
        this.tables = {
            erpTable: {
                title: '-',
                    main: {
                    title: 'bafa_fan_type_number',
                        value: '-'
                },
                params: {
                    title: 'bafa_fan_data',
                        params: {
                        frequency: {
                            title: "Czestotliwosc sieci",
                                code: 'bafa_frequency',
                                value: '-',
                                unit: "[Hz]"
                        },
                        rotor_speed_optimum_point: {
                            title: "Obroty w punkcie optimum sprawności energetycznej",
                                code: 'bafa_rotor_speed_optimum_point',
                                value: '-',
                                unit: "[min<sup>-1</sup>]"
                        },
                        network_speed: {
                            title: "Układ regulacji predkosci obrotowej",
                                code: "bafa_rotor_speed_control_system",
                                value: '-',
                                unit: "[-]",
                                translation: true,
                        },
                        fan_type: {
                            title: "Typ wentylatora",
                                code: "bafa_fan_type",
                                value: "",
                                unit: undefined,
                                translation: true
                        },
                        measurement_category: {
                            title: "Kategoria pomiarowa",
                                code: "bafa_measurement_category",
                                value: '-',
                                unit: "[-]"
                        },
                        efficiency_category: {
                            title: "Kategoria sprawności",
                                code: "bafa_efficiency_category",
                                value: '-',
                                unit: "[-]",
                                translation: true,
                        },
                        static_or_complete_pressure: {
                            title: "Ciśnienie statyczne/ ciśnienie całkowite (psf/pf)",
                                code: "bafa_static_pressure_or_complete_pressure",
                                value: '-',
                                unit: "Pa"
                        },
                        volumetric_intensity: {
                            title: "Natezenie objetosciowe przeplywu na wlocie (q)",
                                code: "bafa_volumetric_intensity",
                                value: '-',
                                unit: "[m<sup>3</sup>/s]"
                        },
                        characteristic_coefficient: {
                            title: "Wspolczynnik charakterystyczny",
                                code: "bafa_characteristic_coefficient",
                                value: '-',
                                unit: "[-]"
                        },
                        compressibility_coefficient: {
                            title: "Wspolczynnik scisliwosci (kps/kp) ~",
                                code: "bafa_compressibility_coefficient",
                                value: '-',
                                unit: "[-]"
                        },
                        installed_power: {
                            title: "Moc zainstalowana",
                                code: "bafa_installed_power",
                                value: '-',
                                unit: "kW"
                        },
                        engine_efficiency: {
                            title: "Sprawność silnika (Nengine)",
                                code: "bafa_engine_efficiency",
                                value: '-',
                                unit: "%"
                        },
                        power_on_shaft: {
                            title: "Moc na wale (Pa)",
                                code: "bafa_power_on_shaft",
                                value: '-',
                                unit: "kW"
                        },
                        electric_power: {
                            title: "Moc elektryczna (Pe)",
                                code: "bafa_electric_power",
                                value: '-',
                                unit: "kW"
                        },
                        useful_fan_power: {
                            title: "Moc uzyteczna wentylatora (Pus)",
                                code: "bafa_useful_fan_power",
                                value: '-',
                                unit: "kW"
                        },
                        general_efficiency: {
                            title: "Sprawność ogolona: statyczna/calkowita (ne)",
                                code: "bafa_general_efficiency_static_complete",
                                value: '-',
                                unit: "%"
                        },
                        efficiency_coefficient: {
                            title: "Wspolczynnik sprawnosci (N)",
                                code: "bafa_efficiency_coefficient",
                                value: '-',
                                unit: "[-]"
                        },
                        target_energetic_efficiency: {
                            title: "Docelowa sprawnosc energetyczna (Ntarget)",
                                code: "bafa_target_energetic_efficiency",
                                value: '-',
                                unit: "%"
                        },
                        minimal_requirements: {
                            title: "Spelnienie minimalnych wymagan dotyczacych sprawnosci energetycznej (Ne >= Ntarget)",
                                code: "bafa_minimal_requirements_of_energetic_efficiency",
                                value: '-',
                                unit: "[-]",
                                translation: true
                        },
                        reached_efficiency: {
                            title: "Osiągnięty współczynnik sprawnosci (Ncurrent)",
                                code: "bafa_reached_efficiency_coefficient",
                                value: '-',
                                unit: "[-]"
                        },
                    }
                },
            },
            bafaTable: {
                title: 'BAFA',
                    main: {
                    title: 'bafa_fan_type_number',
                        value: '-'
                },
                params: {
                    title: 'bafa_fan_data',
                        params: {
                        frequency: {
                            title: "Czestotliwosc sieci",
                                code: 'bafa_frequency',
                                value: '-',
                                unit: "[Hz]"
                        },
                        rotor_speed_optimum_point: {
                            title: "Obroty w punkcie optimum sprawności energetycznej",
                                code: 'bafa_rotor_speed_optimum_point',
                                value: '-',
                                unit: "[min<sup>-1</sup>]"
                        },
                        network_speed: {
                            title: "Układ regulacji predkosci obrotowej",
                                code: "bafa_rotor_speed_control_system",
                                value: '-',
                                unit: "[-]",
                                translation: true,
                        },
                        fan_type: {
                            title: "Typ wentylatora",
                                code: "bafa_fan_type",
                                value: "Wentylator promienowy o łopatkach wygiętych do tyłu w obudowie",
                                unit: undefined,
                                translation: true
                        },
                        measurement_category: {
                            title: "Kategoria pomiarowa",
                                code: "bafa_measurement_category",
                                value: '-',
                                unit: "[-]"
                        },
                        efficiency_category: {
                            title: "Kategoria sprawności",
                                code: "bafa_efficiency_category",
                                value: '-',
                                unit: "[-]",
                                translation: true,
                        },
                        static_or_complete_pressure: {
                            title: "Ciśnienie statyczne/ ciśnienie całkowite (psf/pf)",
                                code: "bafa_static_pressure_or_complete_pressure",
                                value: '-',
                                unit: "Pa"
                        },
                        volumetric_intensity: {
                            title: "Natezenie objetosciowe przeplywu na wlocie (q)",
                                code: "bafa_volumetric_intensity",
                                value: '-',
                                unit: "[m<sup>3</sup>/s]"
                        },
                        characteristic_coefficient: {
                            title: "Wspolczynnik charakterystyczny",
                                code: "bafa_characteristic_coefficient",
                                value: '-',
                                unit: "[-]"
                        },
                        compressibility_coefficient: {
                            title: "Wspolczynnik scisliwosci (kps/kp) ~",
                                code: "bafa_compressibility_coefficient",
                                value: '-',
                                unit: "[-]"
                        },
                        installed_power: {
                            title: "Moc zainstalowana",
                                code: "bafa_installed_power",
                                value: '-',
                                unit: "kW"
                        },
                        engine_efficiency: {
                            title: "Sprawność silnika (&#951;engine)",
                                code: "bafa_engine_efficiency",
                                value: '-',
                                unit: "%"
                        },
                        power_on_shaft: {
                            title: "Moc na wale (Pa)",
                                code: "bafa_power_on_shaft",
                                value: '-',
                                unit: "kW"
                        },
                        electric_power: {
                            title: "Moc elektryczna (Pe)",
                                code: "bafa_electric_power",
                                value: '-',
                                unit: "kW"
                        },
                        useful_fan_power: {
                            title: "Moc uzyteczna wentylatora (Pus)",
                                code: "bafa_useful_fan_power",
                                value: '-',
                                unit: "kW"
                        },
                        general_efficiency: {
                            title: "Sprawność ogolona: statyczna/calkowita (ne)",
                                code: "bafa_general_efficiency_static_complete",
                                value: '-',
                                unit: "%"
                        },
                        efficiency_coefficient: {
                            title: "Wspolczynnik sprawnosci (N)",
                                code: "bafa_efficiency_coefficient",
                                value: '-',
                                unit: "[-]"
                        },
                        target_energetic_efficiency: {
                            title: "Docelowa sprawnosc energetyczna (Ntarget)",
                                code: "bafa_target_energetic_efficiency",
                                value: '-',
                                unit: "%"
                        },
                        minimal_requirements: {
                            title: "Spelnienie minimalnych wymagan dotyczacych sprawnosci energetycznej (Ne >= Ntarget)",
                                code: "bafa_minimal_requirements_of_energetic_efficiency",
                                value: '-',
                                unit: "[-]",
                                translation: true
                        },
                        reached_efficiency: {
                            title: "Osiągnięty współczynnik sprawnosci (Ncurrent)",
                                code: "bafa_reached_efficiency_coefficient",
                                value: '-',
                                unit: "[-]"
                        },
                    }
                },
            },
        };
        this.store = store;
        this.workOnInverter = workOnInverter;
        this.frequency = frequency;
        this.workFrequency = workFrequency;
        this.fan = fan;
        this.calculator = calculator;
        this.silentMode = silentMode;
        this.displayTables = true;
        this.forcedData = forcedData;
        this.forcedMode = !!forcedData['engine'];
    }

    resetTablesValues() {
        for (let param in this.tables.bafaTable.params.params) {
            if (this.tables.bafaTable.params.params.hasOwnProperty(param)) {
                if (this.tables.bafaTable.params.params[param].hasOwnProperty('value')) {
                    this.tables.bafaTable.params.params[param].value = '-';
                }
            }
        }
        for (let param in this.tables.erpTable.params.params) {
            if (this.tables.erpTable.params.params.hasOwnProperty(param)) {
                if (this.tables.erpTable.params.params[param].hasOwnProperty('value')) {
                    this.tables.erpTable.params.params[param].value = '-';
                }
            }
        }
    }

    calculate() {
        const FIXED_VALUE = 2;

        let frequency_multiplier = this.workFrequency / this.frequency;
        let frequency_multiplier_raised_to_the_power = Math.pow(this.workFrequency, 2) /  Math.pow(this.frequency, 2);
        let erp = this.tables.erpTable.params.params;
        let bafa = this.tables.bafaTable.params.params;
        let fan = this.fan;

        this.tables.erpTable.main.value = this.fan.name;
        this.tables.bafaTable.main.value = this.fan.name;

        //TABLES HEADERS
        this.tables.erpTable.title = fan.erp;
        this.tables.bafaTable.title = fan.bafa;

        //FAN TYPE TRANSLATION
        erp.fan_type.value = this.fan.display_name;
        bafa.fan_type.value = this.fan.display_name;

        //A - FREQUENCY
        erp.frequency.value = this.frequency;
        bafa.frequency.value = this.frequency;

        //ADDITIONAL ROTOR OPTIMUM POINT
        (function () {
            let result = this.fan.avg_nominal_speed * (this.frequency / 50) * frequency_multiplier;
            result = Math.round(result);

            erp.rotor_speed_optimum_point.value = result;
            bafa.rotor_speed_optimum_point.value = result;
        }).bind(this)();

        //B - INVERTER
        erp.network_speed.value = this.workOnInverter;
        bafa.network_speed.value = this.workOnInverter;

        //C - STATIC INFO

        //D - CATEGORY
        erp.measurement_category.value = this.fan.category;
        bafa.measurement_category.value = this.fan.category;

        //E - STATIC PRESSURE
        if (this.fan.category === 'C' || this.fan.category === 'A') {
            erp.efficiency_category.value = 'bafa_static_pressure_value';
            bafa.efficiency_category.value = 'bafa_static_pressure_value';
            this.staticPoint = true;
        } else {
            erp.efficiency_category.value = 'bafa_total_pressure_value';
            bafa.efficiency_category.value = 'bafa_total_pressure_value';
            this.staticPoint = false;
        }

        //MAKING A MEASUREMENT

        let measurement = this.calculator.MakeMeasurement(this.store, fan.id_measurement, parseInt(this.frequency), (this.staticPoint) ? 'static' : 'total', 0, 0, true);

        let _this = this;

        let fanObj = {
            params: {}
        };

        let engine = {};

        if(!this.forcedMode) {

            let firstStepFilteredEngines = this.store.state.enginesList.filter((element) => {
                return _this.calculator.enginesFilter(_this.fan.current_type, _this.fan.current_phase, element, this.store);
            });

            let enginesFilteredByEngineRPM = firstStepFilteredEngines.filter((element) => {
                return element.speed == _this.fan.engine_rpm
            });

            engine = this.calculator.findEngine(enginesFilteredByEngineRPM, this.fan, fanObj, measurement, this.store, parseInt(this.frequency));

        } else {
            engine = this.forcedData['engine']
        }

        if (engine === null) {
            this.displayTables = false;
            return;
        }

        let optimal = measurement.graphsObj.optimal;

        //F - PRESSURE DESC
        (function () {
            let result = '';

            if (this.staticPoint) {
                erp.static_or_complete_pressure.code = 'bafa_static_pressure';
                bafa.static_or_complete_pressure.code = 'bafa_static_pressure';

                result = optimal.StaticPressure;
            } else {
                erp.static_or_complete_pressure.code = 'bafa_total_pressure';
                bafa.static_or_complete_pressure.code = 'bafa_total_pressure';

                result = optimal.TotalPressure;
            }

            result *= frequency_multiplier_raised_to_the_power;
            result = result.toFixed(0);

            erp.static_or_complete_pressure.value = result;
            bafa.static_or_complete_pressure.value = result;
        }).bind(this)();

        //G - EFFICIENCY INTENSITY
        (function () {
            let result = '';

            if (this.staticPoint) {
                result = optimal.StaticPreformance;
            } else {
                result = optimal.TotalPreformance;
            }

            result *= frequency_multiplier;
            result = result.toFixed(FIXED_VALUE);

            erp.volumetric_intensity.value = result;
            bafa.volumetric_intensity.value = result;
        }).bind(this)();

        //H - COEFFICIENT
        let optimalPointCharacteristicRatio = (Constants.airPressure + (optimal.TotalPressure * frequency_multiplier_raised_to_the_power)) / Constants.airPressure;
        optimalPointCharacteristicRatio = optimalPointCharacteristicRatio.toFixed(3);

        erp.characteristic_coefficient.value = optimalPointCharacteristicRatio;
        bafa.characteristic_coefficient.value = optimalPointCharacteristicRatio;

        //I - STATIC VALUE
        erp.compressibility_coefficient.value = 1.0.toFixed(1);
        bafa.compressibility_coefficient.value = 1.0.toFixed(1);

        if (this.staticPoint) {
            erp.compressibility_coefficient.code = 'bafa_compressibility_coefficient_kps';
            bafa.compressibility_coefficient.code = 'bafa_compressibility_coefficient_kps';
        } else {
            erp.compressibility_coefficient.code = 'bafa_compressibility_coefficient_kp';
            bafa.compressibility_coefficient.code = 'bafa_compressibility_coefficient_kp';
        }

        //J - INSTALLED POWER
        if (this.frequency === '50') {
            erp.installed_power.value = engine.power_50_hz;
            bafa.installed_power.value = engine.power_50_hz;
        } else {
            erp.installed_power.value = engine.power_60_hz;
            bafa.installed_power.value = engine.power_60_hz;
        }

        //K - EFFICIENCY OF ENGINE
        erp.engine_efficiency.value = (engine.efficiency_3_4 * 100).toFixed(1);
        bafa.engine_efficiency.value = (engine.efficiency_3_4 * 100).toFixed(1);

        //L - POWER ON SHAFT
        (function () {
            let result = '';

            if (this.staticPoint) {
                result = optimal.StaticPower;
            } else {
                result = optimal.TotalPower;
            }

            result = result * (Math.pow(this.workFrequency, 3) /  Math.pow(this.frequency, 3));
            result = (result).toFixed(FIXED_VALUE);

            erp.power_on_shaft.value = result;
            bafa.power_on_shaft.value = result;
        }).bind(this)();

        //M - ELECTRIC POWER
        (function () {
            let result = '';
            result = (erp.power_on_shaft.value / (erp.engine_efficiency.value * 0.01));

            result = result.toFixed(FIXED_VALUE);

            if (result < 0.125 || result > 500) {
                // this.$notifications.add(this.$notifications.TYPES.WARNING, 'BAFA / ERP', this.translate('bafa_error_125_500'))
            } else {
                this.displayTables = true;
            }

            erp.electric_power.value = result;
            bafa.electric_power.value = result;
        }).bind(this)();

        //N - USABLE POWER
        (function () {
            if (this.staticPoint) {
                erp.useful_fan_power.code = 'bafa_useful_fan_power_static';
                bafa.useful_fan_power.code = 'bafa_useful_fan_power_static';
            } else {
                erp.useful_fan_power.code = 'bafa_useful_fan_power_total';
                bafa.useful_fan_power.code = 'bafa_useful_fan_power_total';
            }

            let result = erp.static_or_complete_pressure.value * erp.volumetric_intensity.value * erp.compressibility_coefficient.value * 0.001;

            result = result.toFixed(FIXED_VALUE);

            erp.useful_fan_power.value = result;
            bafa.useful_fan_power.value = result;
        }).bind(this)();

        //O - EFFICIENCY
        (function () {
            let result = '';

            if (this.staticPoint) {
                erp.general_efficiency.code = 'bafa_general_efficiency_static';
                bafa.general_efficiency.code = 'bafa_general_efficiency_static';
            } else {
                erp.general_efficiency.code = 'bafa_general_efficiency_total';
                bafa.general_efficiency.code = 'bafa_general_efficiency_total';
            }

            if (erp.network_speed.value === 'no') {
                result = erp.useful_fan_power.value / erp.electric_power.value;
            } else {

                if (erp.electric_power.value >= 5) {
                    result = (erp.useful_fan_power.value / erp.electric_power.value) * 1.04;
                } else {
                    result = (erp.useful_fan_power.value / erp.electric_power.value) * ((-0.03 * Math.log(erp.electric_power.value)) + 1.088);
                }

            }
            result *= 100;
            result = result.toFixed(1);
            erp.general_efficiency.value = result;
            bafa.general_efficiency.value = result;
        }).bind(this)();

        // NVS-96
        let w1_do10 = 0;
        let w2_do10 = 0;
        let w1_od10 = 0;
        let w2_od10 = 0;

        //P' - EFFICIENCY COEFFICIENT
        if (this.staticPoint) {
            erp.efficiency_coefficient.value = this.fan.n_erp_a_c;
            bafa.efficiency_coefficient.value = this.fan.n_bafa_a_c;
            w1_do10 = this.fan.eta_a_c_w1_do10;
            w2_do10 = this.fan.eta_a_c_w2_do10;
            w1_od10 = this.fan.eta_a_c_w1_od10;
            w2_od10 = this.fan.eta_a_c_w2_od10;
        } else {
            erp.efficiency_coefficient.value = this.fan.n_erp_b_d;
            bafa.efficiency_coefficient.value = this.fan.n_bafa_b_d;
            w1_do10 = this.fan.eta_b_d_w1_do10;
            w2_do10 = this.fan.eta_b_d_w2_do10;
            w1_od10 = this.fan.eta_b_d_w1_od10;
            w2_od10 = this.fan.eta_b_d_w2_od10;
        }

        //R - TARGET EFFICIENCY
        (function () {
            let m = erp.electric_power.value;
            let erp_result = 0;
            let bafa_result = 0;

            let erp_n = parseFloat(erp.efficiency_coefficient.value);
            let bafa_n = parseFloat(bafa.efficiency_coefficient.value);

            if (m <= 10) {
                // erp_result = (4.56 * Math.log(m)) - 10.5 + erp_n;
                // bafa_result = (4.56 * Math.log(m)) - 10.5 + bafa_n;
                // NVS-96
                erp_result = (w1_do10 * Math.log(m)) - w2_do10 + erp_n;
                bafa_result = (w1_do10 * Math.log(m)) - w2_do10 + bafa_n;
            } else {
                // erp_result = (1.1 * Math.log(m)) - 2.6 + erp_n;
                // bafa_result = (1.1 * Math.log(m)) - 2.6 + bafa_n;
                // NVS-96
                erp_result = (w1_od10 * Math.log(m)) - w2_od10 + erp_n;
                bafa_result = (w1_od10 * Math.log(m)) - w2_od10 + bafa_n;
            }

            erp.target_energetic_efficiency.value = erp_result.toFixed(1);
            bafa.target_energetic_efficiency.value = bafa_result.toFixed(1);
        }).bind(this)();

        //S - MINIMAL REQUIREMENTS
        if (erp.general_efficiency.value > erp.target_energetic_efficiency.value) {
            erp.minimal_requirements.value = 'yes';
        } else {
            erp.minimal_requirements.value = 'no';
        }

        if (bafa.general_efficiency.value > bafa.target_energetic_efficiency.value) {
            bafa.minimal_requirements.value = 'yes';
        } else {
            bafa.minimal_requirements.value = 'no';
        }

        //T - ACHIEVED COEFFICIENT
        (function () {
            let result = 0;

            if (erp.electric_power.value <= 10) {
                result = (-4.56 * Math.log(parseFloat(erp.electric_power.value))) + 10.5 + parseFloat(erp.general_efficiency.value);
            } else {
                result = (-1.1 * Math.log(parseFloat(erp.electric_power.value))) + 2.6 + parseFloat(erp.general_efficiency.value);
            }

            result = result.toFixed(1);

            erp.reached_efficiency.value = result;
            bafa.reached_efficiency.value = result;
        }).bind(this)();

        return this.tables;
    }
}

export default ErpBafa
